import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';

/**
 * Aparência dos componentes do Clerk (SignIn/SignUp) alinhada ao tema MUI:
 * card "chapado" sobre o fundo branco do AuthLayout, como no konq-backoffice,
 * e botão principal na cor primária do tenant (ou preto + verde no tema HZero).
 */
export default function useClerkAppearance() {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const contrast = theme.palette.primary.contrastText;
  const hover = theme.palette.primary.dark;

  return useMemo(
    () => ({
      variables: {
        colorPrimary: primary,
        colorText: theme.palette.text.primary,
        colorTextSecondary: theme.palette.text.secondary,
        borderRadius: '8px',
        fontFamily: 'inherit',
      },
      elements: {
        rootBox: { width: '100%', display: 'flex', justifyContent: 'center' },
        cardBox: { boxShadow: 'none', border: 'none', width: '100%' },
        card: { boxShadow: 'none', border: 'none', background: 'transparent', padding: '8px 0' },
        headerTitle: { fontSize: '1.25rem', fontWeight: 700 },
        formButtonPrimary: {
          'backgroundColor': primary,
          'color': contrast,
          'fontWeight': 600,
          'fontSize': '14px',
          'textTransform': 'none',
          'boxShadow': 'none',
          '&:hover, &:focus': { backgroundColor: hover, color: contrast },
        },
        formFieldInput: { padding: '10px 12px' },
        footer: { background: 'transparent' },
        footerActionLink: { color: primary, fontWeight: 600 },
        socialButtonsBlockButton: { fontWeight: 600 },
      },
    }),
    [primary, contrast, hover, theme.palette.text.primary, theme.palette.text.secondary],
  );
}
